<template>
  <v-card ripple class="pt-1">
    <!-- Title Row -->
    <v-row>
      <v-container class="pb-0 pt-0 d-flex">
        <v-col cols="10" class="text-left pb-0 mt-1 text-left">
          <router-link v-if="titleLink" :to="titleLink"
            ><p class="font-weight-black">
              {{ title }}
            </p></router-link
          >
          <p v-if="!titleLink" class="font-weight-black">
            {{ title }}
          </p>
        </v-col>
        
        <v-col v-if="titleIcon" cols="2" class="text-left pb-0 mt-1 text-right">
          <tool-tip
            :hoverText="titleIconHoverText"
            text=""
            position="top"
            :iconName="titleIcon"
            :iconClickFunction="iconClickFunction"
            class="small-font"
          >
          </tool-tip>
        </v-col>
      </v-container>
    </v-row>
    <v-divider></v-divider>

    <!-- Data Items -->
    <v-row class="mt-3">
      <v-container
        class="d-flex pb-0 pt-0"
        v-for="cardPair in cardFieldNameValuePairs"
        :key="cardPair[0]"
      >
        <v-col cols="5" class="text-left pt-0 pb-0">
          <p class="font-weight-medium grey-text small-font">
            <b>{{ cardPair[0] }}</b>
          </p>
        </v-col>
        <v-col cols="7" class="text-left pt-0 pb-0">
          <tool-tip
            :text="
              cardPair[1].substring(0, maxStringCharacterLengthDataCard)
            "
            :hoverText="cardPair[1]"
            position="bottom"
            :maxTextLength="maxStringCharacterLengthDataCard"
            class="small-font"
          >
          </tool-tip>
        </v-col>
      </v-container>
    </v-row>
  </v-card>
</template>
<script>
import ToolTip from "./ToolTip.vue";

export default {
  components: {
    ToolTip,
  },
  props: {
    title: String,
    titleIcon: String,
    titleIconHoverText: String,
    titleLink: String,
    cardFieldNameValuePairs: Array,
    maxStringCharacterLengthDataCard: Number,
    iconClickFunction: Function,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>